import {
  Button,
  Icon,
  Input,
  Spin,
  Table,
  Row,
  Dropdown,
  Menu,
  Popconfirm,
  Empty,
} from "antd";
import React, { Fragment } from "react";
import Highlighter from "react-highlight-words";
import "../../components/general/drawer/AdaptiveDrawer.css";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { PackageAndPrivilegeService } from "../../services/packageAndPrivilege/PackageAndPrivilegeService";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./PackagesTable.css";
import history from "../../utils/history";
import { showSuccessToast } from "../general/ToastHelper";
import { withTranslation } from "react-i18next";
import i18next from "i18next";

class PackageTable extends React.Component {
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("packages");
    this.packageAndPrivilegeService = new PackageAndPrivilegeService();
    this.state = {
      isFetching: false,
      searchText: "",
      data: [],
    };
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={
            this.props.context.curr_dir === "ltr" &&
            this.props.context.curr_lang === "en"
              ? { width: 100, marginRight: 8 }
              : { width: 100, marginLeft: 8 }
          }
        >
          {this.props.t("Search")}
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 80 }}
        >
          {this.props.t("Reset")}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: "#d73a31" }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] != null &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  componentDidMount() {
    this.getAllPackages();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async getAllPackages() {
    try {
      this.setState({ isFetching: true });
      let data = await this.packageAndPrivilegeService.getPackagesList(
        this.props.context.session_id
      );

      this.setState({ data: this.formatData(data), isFetching: false });
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  formatData(data) {
    const updated_data = [];
    for (var i = 0; i < data.ivrList.length; i++) {
      var row = {};
      row["key"] = i + 1;
      row["pkgCode"] = data.ivrList[i]["pkgCode"];
      row["pkgName"] = data.ivrList[i]["pkgName"];
      // row["pkgRatio"] = data.ivrList[i]["pkgRatio"];
      row["createdAt"] = data.ivrList[i]["createdAt"].split("T")[0];
      updated_data.push(row);
    }
    return updated_data;
  }

  renderActionDropdown(record) {
    const menu = (
      <Menu>
        <Menu.Item onClick={() => this.editPackage(record)}>
          <span>{this.props.t("Edit package")}</span>
          <Icon className={"edit-account-style"} type="edit" />
          {/* </Link> */}
        </Menu.Item>
        <Menu.Item>
          <Popconfirm
            title={this.props.t("Are you sure delete this package?")}
            onConfirm={() => this.deletePackage(record)}
            okText={this.props.t("Yes")}
            cancelText={this.props.t("No")}
          >
            <a href="#" style={{ color: "rgba(0, 0, 0, 0.65)" }}>
              {this.props.t("Delete")}
            </a>
            <Icon className={"delete-account-style"} type="delete" />
          </Popconfirm>
        </Menu.Item>
      </Menu>
    );
    return (
      <Dropdown overlay={menu}>
        <Button size="small" style={{ borderWidth: 0 }}>
          <Icon item={record} type="more" />
        </Button>
      </Dropdown>
    );
  }

  async deletePackage(record) {
    try {
      let data = await this.packageAndPrivilegeService.deletePackage(
        this.props.context.session_id,
        record
      );
      showSuccessToast(this.props.t("Package deleted successfully"));
      this.handleRefresh();
    } catch (e) {
      handleError(e);
    }
  }

  editPackage = (record) => {
    history.push(`/home/packages/edit/${record.pkgCode}/${record.pkgName}`);
  };

  addNewPackage = () => {
    history.push("/home/packages/create");
  };

  handleRefresh() {
    this.getAllPackages();
  }

  render() {
    const columns = [
      {
        title: this.props.t("Package code"),
        dataIndex: "pkgCode",
        key: "pkgCode",
        width: "20%",
        ...this.getColumnSearchProps("pkgCode"),
      },
      {
        title: this.props.t("Package name"),
        dataIndex: "pkgName",
        key: "pkgName",
        width: "20%",
      },
      // {
      //   title: this.props.t("Package Ratio"),
      //   dataIndex: "pkgRatio",
      //   key: "pkgRatio",
      //   width: "20%",
      // },
      {
        title: this.props.t("Created at"),
        dataIndex: "createdAt",
        key: "createdAt",
        width: "20%",
      },
      {
        title: this.props.t("Action"),
        dataIndex: "operation",
        render: (text, record) =>
          this.state.data.length >= 1
            ? this.renderActionDropdown(record)
            : null,
      },
    ];

    let { isFetching } = this.state;
    return (
      <Page title={this.props.t("Packages")}>
        {isFetching ? (
          <Spin></Spin>
        ) : (
          <div>
            <Row style={{ marginTop: "25px" }}></Row>
            <Button
              className="button-add-account"
              onClick={this.addNewPackage}
              icon="plus"
            />
            <span>{this.props.t("Add new package")}</span>

            <Table
              columns={columns}
              bodyStyle={{
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                borderRadius: "8px",
                marginBottom: "25px",
              }}
              dataSource={this.state.data}
              pagination={{
                position: "bottom",
                pageSize: 10,
              }}
              bordered
              locale={{
                emptyText: (
                  <Empty
                    description={i18next.t("Empty")}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
              }}
            />
          </div>
        )}
      </Page>
    );
  }
}

export default withSharedStateConsumer(withTranslation()(PackageTable));
